import React from "react";

const LABELS = {
  hr: {
    title: "Kontakt (neobavezno)", hint: "Za brže javljanje oko vašeg dolaska.", phone: "Broj telefona", email: "E-mail",
    billing_title: "Podaci za račun (neobavezno)", billing_hint: "Potrebno samo ako želite da vam izdamo račun na ovo ime.",
    address: "Adresa", postal_code: "Poštanski broj", oib: "OIB / porezni broj",
  },
  en: {
    title: "Contact (optional)", hint: "So we can reach you about your arrival.", phone: "Phone number", email: "E-mail",
    billing_title: "Billing details (optional)", billing_hint: "Only needed if you'd like an invoice issued to this name.",
    address: "Address", postal_code: "Postal code", oib: "Tax ID / VAT number",
  },
  de: {
    title: "Kontakt (optional)", hint: "Damit wir Sie wegen Ihrer Ankunft erreichen können.", phone: "Telefonnummer", email: "E-Mail",
    billing_title: "Rechnungsdaten (optional)", billing_hint: "Nur nötig, wenn wir eine Rechnung auf diesen Namen ausstellen sollen.",
    address: "Adresse", postal_code: "Postleitzahl", oib: "Steuernummer / USt-IdNr.",
  },
  it: {
    title: "Contatto (facoltativo)", hint: "Per contattarvi riguardo al vostro arrivo.", phone: "Numero di telefono", email: "E-mail",
    billing_title: "Dati di fatturazione (facoltativo)", billing_hint: "Necessari solo se desiderate una fattura intestata a questo nome.",
    address: "Indirizzo", postal_code: "Codice postale", oib: "Codice fiscale / P.IVA",
  },
};

// Optional lead-guest phone + email + billing details on the public check-in form.
export function CheckinContactFields({ lang, value, onChange }) {
  const l = LABELS[lang] || LABELS.hr;
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const Field = ({ label, span2, children }) => (
    <label className={`block ${span2 ? "sm:col-span-2" : ""}`}>
      <span className="mb-1.5 block text-[13px] font-semibold" style={{ color: "var(--cf-text)" }}>{label}</span>
      {children}
    </label>
  );
  return (
    <>
      <div className="mt-6 border-t pt-5" style={{ borderColor: "var(--cf-border)" }} data-testid="checkin-contact-section">
        <h3 className="text-base font-bold" style={{ color: "var(--cf-text)", fontFamily: "var(--cf-heading-font)" }}>{l.title}</h3>
        <p className="mt-0.5 text-xs opacity-70" style={{ color: "var(--cf-text)" }}>{l.hint}</p>
        <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <Field label={l.phone}>
            <input type="tel" autoComplete="tel" value={value.phone} onChange={set("phone")} className="cf-input" data-testid="checkin-contact-phone" />
          </Field>
          <Field label={l.email}>
            <input type="email" autoComplete="email" value={value.email} onChange={set("email")} className="cf-input" data-testid="checkin-contact-email" />
          </Field>
        </div>
      </div>
      <div className="mt-6 border-t pt-5" style={{ borderColor: "var(--cf-border)" }} data-testid="checkin-billing-section">
        <h3 className="text-base font-bold" style={{ color: "var(--cf-text)", fontFamily: "var(--cf-heading-font)" }}>{l.billing_title}</h3>
        <p className="mt-0.5 text-xs opacity-70" style={{ color: "var(--cf-text)" }}>{l.billing_hint}</p>
        <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <Field label={l.address} span2>
            <input autoComplete="street-address" value={value.address || ""} onChange={set("address")} className="cf-input" data-testid="checkin-contact-address" />
          </Field>
          <Field label={l.postal_code}>
            <input autoComplete="postal-code" value={value.postal_code || ""} onChange={set("postal_code")} className="cf-input" data-testid="checkin-contact-postal" />
          </Field>
          <Field label={l.oib}>
            <input value={value.oib || ""} onChange={set("oib")} className="cf-input" data-testid="checkin-contact-oib" />
          </Field>
        </div>
      </div>
    </>
  );
}
